
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { logger } from "@/utils/logger";

export function useUserProfile() {
  const { toast } = useToast();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userPlan, setUserPlan] = useState<string | null>(null);

  useEffect(() => {
    const checkUserRole = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session) {
          navigate("/entrar");
          return;
        }
        
        const { data: role, error } = await supabase.rpc('get_current_user_role');
        
        if (error) {
          logger.error("Erro ao verificar papel:", error);
          toast({
            variant: "destructive",
            title: "Erro de autenticação",
            description: "Não foi possível verificar suas permissões."
          });
          return;
        }
        
        setIsAdmin(role === 'admin');
        
        const { data: profile, error: profileError } = await supabase
          .from('profiles')
          .select('plan_type')
          .eq('id', session.user.id)
          .maybeSingle();
          
        if (!profileError && profile) {
          setUserPlan(profile?.plan_type || 'basic');
        }
      } catch (error) {
        logger.error("Erro na verificação:", error);
        toast({
          variant: "destructive",
          title: "Erro de autenticação",
          description: "Ocorreu um erro ao verificar suas permissões."
        });
      } finally {
        setIsLoading(false);
      }
    };
    
    checkUserRole();
  }, [navigate, toast]);

  return { isLoading, isAdmin, userPlan };
}
